<!-- Main Application Container -->
<div class="app-root">
  <!-- Router outlet will render PublicLayoutComponent or PrivateLayoutComponent -->
  <router-outlet></router-outlet>
</div>

